import * as React from 'react';


export default class Nfnoteadded extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <svg viewBox="0 0 12 12" className={this.props.className} xmlnsXlink="http://www.w3.org/1999/xlink">
        <g fill="none" fillRule="evenodd" stroke="#FFF">
            <path strokeLinecap="square" d="M3.5 4.5h4M3.5 7.5h3"/>
            <path d="M1.5 1.5h9v10h-9z"/>
        </g>
      </svg>
    )
  }
}
